import { gql } from '@apollo/client'

export const MUTATION_ASSIGN_DEVICE_TO_EMPLOYEE = gql`
  mutation mutationAssignDeviceToEmployee($input: AssignDeviceToEmployeeInput) {
    createAssignDeviceToEmployee(input: $input) {
      id
    }
  }
`
